export enum ApplicationRole {
  AppAdmin = 'Application Administrator',
  SiteAdmin = 'Site Administrator',
  Contributor = 'Contributor',
  Viewer = 'Viewer',
}
